import { createAction, props } from '@ngrx/store';
import { Role } from '../../models/role';

export const loadRoles = createAction(
  '[Roles] Load Roles'
);

export const loadRolesSuccess = createAction(
  '[Roles] Load Roles Success',
  props<{entities: Role[]}>()
);

export const loadRolesFail = createAction(
  '[Roles] Load Roles Fail'
);
